<template>
  <div class="ml-2 mb-3">
    <v-dialog v-model="dialogCourseGroup" max-width="70%">
      <CourseGroup
          v-if="courseGroupId"
          :courseGroupId="courseGroupId"
          ref="courseGroup"
          @close="dialogCourseGroup = false"
          @reload="reload"
      >
      </CourseGroup>
    </v-dialog>

    <v-dialog v-model="dialogDetailCourseGroup" max-width="70%">
      <DetailCourseGroup
          v-if="courseGroupId"
          :courseGroupId="courseGroupId"
          ref="detailCourseGroup"
          @close="dialogDetailCourseGroup = false"
      >
      </DetailCourseGroup>
    </v-dialog>

    <v-dialog v-model="dialogStudents" max-width="700px">
      <Students
          v-if="courseGroupId"
          :courseGroupId="courseGroupId"
          :courseId="courseId"
          ref="students"
          @close="dialogStudents = false"
      >
      </Students>
    </v-dialog>

    <v-data-table
        ref="table"
        :items="items"
        :loading="loadingItems"
        :headers="headers"
        hide-default-footer
        loading-text="Buscando..."
        no-data-text="Sem registros"
        class="elevation-0 mytable content-table"
        style="width: 110%"
    >
      <template v-slot:[`item.startDate`]="{ item }">
        {{ item.startDate ? formatDate(item.startDate) : '-' }}
      </template>

      <template v-slot:[`item.endDate`]="{ item }">
        {{ item.endDate ? formatDate(item.endDate) : '-' }}
      </template>

      <template v-slot:[`item.daysOfTheWeek`]="{ item }">
        {{ formatDaysOfTheWeek(item.daysOfTheWeek) }}
      </template>

      <template v-slot:[`item.period`]="{ item }">
        {{ formatPeriod(item.period) }}
      </template>

      <template v-slot:[`item.level`]="{ item }">
        {{ formatLevel(item.level) }}
      </template>

      <template v-slot:[`item.active`]="{ item }">
        {{ item.active ? 'Sim' : 'Não' }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <section>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 quinary-button"
                  color="quaternary"
                  @click="showDialogStudents(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-account-multiple-check</v-icon>
              </v-btn>
            </template>
            <span>Ver inscritos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 quinary-button"
                  color="quaternary"
                  @click="showDialogDetailCourseGroup(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>Detalhar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  style="border-radius: 4px"
                  width="35"
                  height="35"
                  small
                  class="ma-1 quinary-button"
                  color="quaternary"
                  @click="showDialogEdit(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </section>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="filter.totalItems > filter.pageSize"
              :currentPage="filter.currentPage"
              :totalItems="filter.totalItems"
              :page="filter.page"
              :pageSize="filter.pageSize"
              :totalPages="filter.totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Utils from "@/Utils/FormatDate";
import CourseGroup from "@/views/pages/Courses/components/CourseGroup.vue";
import Pagination from "@/views/pages/components/Pagination.vue";
import DetailCourseGroup from "@/views/pages/Courses/components/DetailCourseGroup.vue";
import Students from "@/views/pages/Courses/components/Students.vue";

export default {
  name: "CourseGroups",
  components: {Students, DetailCourseGroup, Pagination, CourseGroup},
  computed: {},

  props: {},

  created() {
  },

  async mounted() {
    await this.paginatedList()
  },
  data() {
    return {
      dialogStudents: false,
      dialogCourseGroup: false,
      dialogDetailCourseGroup: false,
      courseGroupId: null,
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2,
        max: 10
      },
      active: [
        {name: "Não", value: 'false'},
        {name: "Sim", value: true},
      ],
      periods: [
        {name: "Matutino", value: "0"},
        {name: "Vespertino", value: '1'},
        {name: "Noturno", value: '2'}
      ],
      levels: [
        {name: "Iniciante", value: "0"},
        {name: "Intermediário", value: '1'},
        {name: "Avançado", value: '2'}
      ],
      daysOfTheWeek: [
        {name: "Domingo", value: 0},
        {name: "Segunda-feira", value: 1},
        {name: "Terça-feira", value: 2},
        {name: "Quarta-feira", value: 3},
        {name: "Quinta-feira", value: 4},
        {name: "Sexta-feira", value: 5},
        {name: "Sábado", value: 6}
      ],
      courseForm: false,
      courseId: null,
      items: [],
      loadingItems: false,
      headers: [
        {
          text: "Curso",
          align: "start",
          value: "course.name",
          sortable: false,
        },
        {
          text: "Horário de início",
          align: "start",
          value: "startTime",
          sortable: false,
        },
        {
          text: "Hora de término",
          align: "start",
          value: "endTime",
          sortable: false,
        },
        {
          text: "Data de início",
          align: "start",
          value: "startDate",
          sortable: false,
        },
        {
          text: "Data de término",
          align: "start",
          value: "endDate",
          sortable: false,
        },
        {
          text: "Nível",
          align: "start",
          value: "level",
          sortable: false,
        },
        {
          text: "Vagas",
          align: "start",
          value: "numberOfVacancies",
          sortable: false,
        },
        {
          text: "Ativo",
          align: "start",
          value: "active",
          sortable: false,
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      filter: {
        pageSize: 10,
        currentPage: 0,
        page: 1,
        totalPages: 1,
        totalItems: 1,
      },
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    showDialogStudents(courseGroup) {
      console.log(courseGroup)
      this.courseGroupId = courseGroup.id
      this.courseId = courseGroup.courseId
      this.dialogStudents = true
      setTimeout(() => {
        this.$refs.students.getStudents()
      }, 100)
    },

    formatDaysOfTheWeek(daysOfTheWeek) {
      return this.daysOfTheWeek.filter(x => daysOfTheWeek.includes(x.value)).map(x => x.name).join(', ')
    },

    formatLevel(level) {
      return this.levels.find(x => x.value == level).name;
    },

    formatPeriod(period) {
      return this.periods.find(x => x.value == period).name;
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    async paginatedList() {
      try {
        const {items, pager} = await this.apiService.post("courseGroup/paginated", this.filter, false)
        this.items = items
        this.filter.totalItems = pager.totalItems
        this.filter.currentPage = pager.currentPage
        this.filter.pageSize = pager.pageSize
        this.filter.totalPages = pager.totalPages
      } catch (e) {

      }
    },
    async backPage() {
      this.filter.page -= 1;
      await this.paginatedList();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.paginatedList();
    },
    async reload() {
      this.filter.page = 1;
      await this.paginatedList();
    },

    async goToRoute(route) {
      await this.$router.push(route);
    },

    showDialogDetailCourseGroup(courseGroup){
      this.courseGroupId = courseGroup.id
      this.dialogDetailCourseGroup = true
      setTimeout(() => {
        this.$refs.detailCourseGroup.getCourseGroup()
      }, 100)
    },

    showDialogEdit(courseGroup){
      this.courseGroupId = courseGroup.id
      this.dialogCourseGroup = true
      setTimeout(() => {
        this.$refs.courseGroup.getCourseGroup()
      }, 100)
    }

  },

  watch: {},
};
</script>

<style lang='scss' scoped>
#chartRecipeAndOrder {
  width: 100%;
}

#chartPaymentMethod {
  width: 100%;
}

.card-red {
  background: linear-gradient(to bottom, #f54784, #d62828);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

.card-black {
  background: linear-gradient(to bottom, #000000, #666666);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 10px 15px;
  text-align: left;
}

tr {
  cursor: pointer;
}

th {
  font-weight: bold;
  border-bottom: 2px solid #ddd;
}

/* coluna receita */
td.receita {
  background: linear-gradient(to right, #f8d7da, #f5c6cb);
  text-align: left;
  font-weight: bold;
  color: #333;
}

/* coluna metros */
td.metros {
  background: linear-gradient(to right, #f8d7da, #f1b0b7);
  text-align: left;
  font-weight: bold;
  color: #333;
}

tr:nth-child(even) td {
  background-color: #fafafa;
}
.remove-button {
  border: 1px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}
</style>
